import React, { useEffect, useState } from "react";
import { Col, Row, Wrapper } from "./index.styled";
import CustomCard from "common/custom-card/CustomCard";

export default function ComingSoonPage() {

    return (
        <Wrapper>
            <Row>
                <Col size={12}>
                    <div className="coming-label">
                        <h1>Coming Soon</h1>
                    </div>
                </Col>
            </Row>
        </Wrapper>
    );
}
